import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService, AuthenticationService, ShadowService } from 'src/app/shared/_services';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.page.html',
  styleUrls: ['./password-reset.page.scss'],
})
export class PasswordResetPage implements OnInit {
  currentUser: any;
  subscription: any;
  error: string;
  token: any;
  heading: string;
  passwordText: string;
  pattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#"@$!%*?&])[A-Za-z\d$#"@$!%*?&].{7,}';
  passwordResetForm: FormGroup;
  loading = false;
  showIcon = true;
  inputType = 'password';
  showNewLink: boolean;

  constructor(
    private formBuilder: FormBuilder, private router: Router,
    private auth: AuthenticationService, private alertService: AlertService,
    private shadowService: ShadowService
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  public errorMessages = {
    newPassword: [
      { type: 'required', message: 'Password is required' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: 'Password cannot be less than 8 characters' +
        ' and must contain a minimum of 1 Uppercase Letter, 1 Special Character and 1 Number'
      }
    ],
    confirmPassword: [
      { type: 'required', message: 'Please retype password' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: 'Password cannot be less than 8 characters and must contain a minimum' +
        ' of 1 Uppercase Letter, 1 Special Character and 1 Number'
      }
    ]
  };

  get newPassword() {
    return this.passwordResetForm.get('newPassword');
  }

  get confirmPassword() {
    return this.passwordResetForm.get('confirmPassword');
  }

  togglePassword() {
    this.showIcon = !this.showIcon;
    this.inputType === 'password' ? this.inputType = 'text' : this.inputType = 'password';
  }

  passwordConfirm(formGroup: FormGroup) {
    const { value: newPassword } = formGroup.get('newPassword');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return newPassword === confirmPassword ? null : { passwordNotMatch: true };
  }

  saveProfileDetails() {
    this.router.navigateByUrl('/dashboard');
  }

  passwordReset() {
    this.error = null;
    if (this.passwordResetForm.invalid) {
      return;
    }

    this.loading = true;
    this.auth.passwordReset(this.newPassword.value, this.confirmPassword.value, this.token)
    .subscribe(
      (response: any) => {
        console.log(response);
        this.loading = false;
        this.alertService.standardAlert('Password ' + this.passwordText + '! ' + 'Taking you to your app');
        setTimeout(() => {
          this.alertService.dismissAlert();
          window.location.href = 'https://bank3d.page.link/hello';
        }, 3000);
      },
      error => {
        console.log(error);
        this.error = error;
        this.loading = false;
        if (error.error.message.includes('invalid or expired')) {
          this.showNewLink = true;
          this.alertService.standardAlert('Link is invalid or has expired');
        } else {
          this.alertService.standardAlert(error.error.message + ' Unable to set your password. Please refresh and try again');
        }
      }
    );
  }

  ionViewWillEnter() {
    document.title = 'Password Reset | Bank3D';
    this.shadowService.button();
  }

  ngOnInit() {
    const queryParams = window.location.search;
    if (queryParams.includes('token')) {
      this.token = queryParams.slice(7);
      this.heading = 'Create your Password';
      this.passwordText = 'Set';
    } else if (queryParams.includes('resetToken')) {
      this.token = queryParams.slice(12);
      this.heading = 'Password Reset';
      this.passwordText = 'Reset';
    }
    this.passwordResetForm = this.formBuilder.group({
      newPassword: [
        '', [Validators.required, Validators.minLength(8),
          Validators.pattern(this.pattern)]
      ],
      confirmPassword: [
        '', [Validators.required, Validators.minLength(8),
          Validators.pattern(this.pattern)]
      ],
    },
    {
      validators: this.passwordConfirm.bind(this)
    });
    window.addEventListener('keydown', (e) => {
      const pathname = window.location.pathname;
      if (e.key === 'Enter' && this.passwordResetForm.valid && pathname.includes('password-reset')) {
        this.passwordReset();
      }
    });
  }
}
